"use client";

import * as React from "react";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../utils";

const toggleVariants = cva(
  "al-inline-flex al-items-center al-justify-center al-gap-2 al-rounded-sm al-text-sm al-font-medium hover:al-bg-muted hover:al-text-muted-foreground disabled:al-pointer-events-none disabled:al-opacity-50 data-[state=on]:al-bg-brand data-[state=on]:al-text-white [&_svg]:al-pointer-events-none [&_svg:not([class*='size-'])]:al-size-4 [&_svg]:al-shrink-0 focus-visible:al-border-ring focus-visible:al-ring-ring/50 focus-visible:al-ring-[3px] al-outline-none al-transition-[color,box-shadow] aria-invalid:al-ring-destructive/20 dark:aria-invalid:al-ring-destructive/40 aria-invalid:al-border-destructive al-whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "al-bg-transparent",
        outline:
          "al-border al-border-input al-bg-transparent al-shadow-xs hover:al-bg-accent hover:al-text-accent-foreground",
      },
      size: {
        default: "al-h-9 al-px-2 al-min-w-9",
        sm: "al-h-8 al-px-1.5 al-min-w-8",
        lg: "al-h-10 al-px-2.5 al-min-w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

function Toggle({
  className,
  variant,
  size,
  ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>) {
  return (
    <TogglePrimitive.Root
      data-slot="toggle"
      className={cn(toggleVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Toggle, toggleVariants };
